import { createContext } from "react"

export const LayoutEditorContext = createContext({} as any)